export default __webpack_public_path__ + "static/banner-0bd2bac1ef79fa9f7768430885414d08.jpg";